var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinalNotSolved(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 95,
    viewBox: "0 0 96 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "final-past",
    d: "M3 15.9447L25.2711 3L47.7695 15.5522L48 41.0522L25.7289 54L3.23047 41.4447L3 15.9447Z",
    fill: "#545454",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "final-future",
    d: "M48 15.9447L70.2711 3L92.7695 15.5522L93 41.0522L70.7289 54L48.2305 41.4447L48 15.9447Z",
    fill: "#545454",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "final-present",
    d: "M26 53.9447L48.2711 41L70.7695 53.5522L71 79.0522L48.7289 92L26.2305 79.4447L26 53.9447Z",
    fill: "#545454",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3047 53.614C53.9959 53.614 58.6095 48.9994 58.6095 43.307C58.6095 37.6146 53.9959 33 48.3047 33C42.6136 33 38 37.6146 38 43.307C38 48.9994 42.6136 53.614 48.3047 53.614Z",
    fill: "#545454",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalNotSolved);
export default __webpack_public_path__ + "static/media/finalNotSolved.9ce7d582.svg";
export { ForwardRef as ReactComponent };